import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Base64 } from 'js-base64';
import { createCodeContainer } from 'js/actions';
import Button from 'js/components/elements/editors/mui/Button';
import { TransformType } from 'new/components/ReusableTransform/types';
import { buildCodeContainerConfig } from 'new/components/flows/shared/customProcessor';
import { IconButton } from 'new/elements/IconButton/IconButton';
import { TextField } from 'new/elements/TextField';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import classes from 'new/components/flows/shared/customProcessor/SaveCustomProcessor.module.scss';

const SaveCustomProcessor = ({ sourceConfig }) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState<string | null>(null);
  const { customProcessorCode: code, packages, extra_data } = sourceConfig;

  const onClose = () => {
    setIsOpen(false);
    setError(null);
  };

  const onNameChanged = (event) => {
    setName(event.target.value);
    setError(null);
  };

  const onDescriptionChanged = (event) => {
    setDescription(event.target.value);
  };

  const onSaveCustomProcessor = () => {
    setIsOpen(true);
  };

  const onConfirm = () => {
    if (!name) {
      setError('Please enter a name.');
      return;
    }

    dispatch(
      createCodeContainer({
        name,
        description,
        resource_type: 'source_custom',
        output_type: TransformType.CUSTOM,
        code_type: 'python',
        code_encoding: 'base64',
        code: Base64.encode(code),
        code_config: buildCodeContainerConfig(packages, extra_data),
        reusable: true,
      }),
    )
      .then(() => {
        onClose();
      })
      .catch((e) => {
        console.log('Error creating code container:', e);
      });
  };

  return (
    <div>
      <Button
        className={classes.saveButton}
        variant="outlined"
        color="primary"
        onClick={onSaveCustomProcessor}
      >
        Save as a Reusable Connector Processor
      </Button>
      <Dialog className={classes.dialog} open={isOpen} onClose={onClose}>
        <DialogTitle className={classes.dialogTitle}>
          Save Connector Processor
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialogContent} dividers>
          <div className={classes.inputContainer}>
            <label htmlFor="custom-processor-name">
              <Typography variant="subheading2">Connector Processor Name</Typography>
            </label>
            <TextField id="custom-processor-name" value={name} autoFocus onChange={onNameChanged} />
          </div>
          <div className={classes.inputContainer}>
            <label htmlFor="custom-processor-description">
              <Typography variant="subheading2">Description</Typography>
            </label>
            <TextField
              id="custom-processor-description"
              value={description}
              placeholder="Optional"
              onChange={onDescriptionChanged}
            />
          </div>
          {error && <div className={classes.error}>{error}</div>}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button variant="outlined" color="basic" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="ghost" color="primary" onClick={onConfirm}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SaveCustomProcessor;
